/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Author: Wes (https://sketchfab.com/wimell)
License: SKETCHFAB Standard (https://sketchfab.com/licenses)
Source: https://sketchfab.com/3d-models/iphone-16-free-d58591e88a824dfd8cef0af616273b02
Title: iPhone 16 - Free
*/

import React, { forwardRef, Suspense, useEffect, useRef, useState } from 'react'
import { Html, useGLTF } from '@react-three/drei'
import * as THREE from "three";
import { Eye, EyeOff, Mail, Lock, User, Phone, UserStar } from 'lucide-react';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { CustomEase } from 'gsap/CustomEase';
import { useNavigate } from 'react-router-dom';
import { API_login_route as login_route,API_register_route as register_route } from "Var/URLS";
import axios from "axios";
import { OrbitControls, TransformControls , useHelper ,useProgress} from "@react-three/drei";
import { ScrollTrigger } from 'gsap/all';
import Preloader from 'Preloader';
gsap.registerPlugin(CustomEase,ScrollTrigger);
const LoginForm = forwardRef(({screenData,login,setAuth,setuserR,textLeave,textEnter,start,setanimation}, ref) => {
  let navigate = useNavigate()

  const [formData, setFormData] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleChange = (e) => {
          const { name, value } = e.target;
          setFormData({
              ...formData,
              [name]: value
          });

  };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true)
        const token = localStorage.getItem("token"); 
        let res = await axios.post(`${login ? login_route : register_route}`, formData, {
            withCredentials: true,  headers: {
            Authorization: token ? `Bearer ${token}` : undefined,
          },
        })
        let auth = await res.data
        if (login) {
            if (auth.token) {
              localStorage.setItem("token", auth.token);
            }
            if (auth['us-va']) {
                window.sessionStorage.binar = 'true'
                setIsLoading(false)
                setAuth(auth['us-va'])
                setuserR(auth['us-r'] =='cole' ? 'admin':'user')
                if (auth['us-r'] === 'cole') {
                    return navigate('/admin')
                }
                return navigate('/') 
            }
   
        }
        setIsLoading(false)
        alert(auth.msg)
        navigate('/login')
    };

  return (<Suspense fallback={<Html center>loading....</Html>}>

          <Html
          transform
          distanceFactor={1}
          scale={4}
          style={{
            backfaceVisibility: "hidden",
            WebkitBackfaceVisibility: "hidden",
          }}
          zIndexRange={[14, 14]} 
          occlude 
          position={[0,0,0.4]}
            >
    <div 
      ref={ref}
      className='select-none'
      id='Login'
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundColor:'#e2e2e2',
        width: `${screenData.width * 80}px`, 
        height: `${screenData.height * 40}px`,
        maxHeight: '70vh',
        padding: '24px',
      }}>
      <div
        style={{
          maxWidth: '400px',
          margin: '0 auto',
          width: '100%',
        }}>
        <div style={{ marginBottom: '48px' }}>
          <h1
            style={{
              fontSize: login ? '32px' : '30px',
              fontWeight: '700',
              color: '#000',
              marginBottom: '8px',
              letterSpacing: '-0.5px',
              margin: '0 0 8px 0',
            }}>
            {login ? 'Welcome Back' : "Create your first account"}
          </h1>
          <p
            style={{
              fontSize: '16px',
              color: '#666',
              fontWeight: '400',
              margin: '0',
            }}>
            Sign in to continue
          </p>
        </div>

        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          {!login &&          
          <div style={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: '#f5f5f5',
              borderRadius: '12px',
              marginBottom: '16px',
              paddingLeft: '16px',
              paddingRight: '16px',
              height: '56px',
              border: '1px solid transparent'}}>
              <User size={20} color="#666" strokeWidth={2} style={{ marginRight: '12px' }} />
              <input    
              style={{
                flex: 1,
                fontSize: '16px',
                color: '#000',
                height: '100%',
                border: 'none',
                backgroundColor: 'transparent',
                outline: 'none',
                fontFamily: 'inherit',
              }} type="text" 
              onChange={handleChange} 
              id="username" 
              name="username"
              autoComplete="username"
              placeholder="Username"
              required/>

              </div>}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: '#f5f5f5',
              borderRadius: '12px',
              marginBottom: '16px',
              paddingLeft: '16px',
              paddingRight: '16px',
              height: '56px',
              border: '1px solid transparent',
            }}>
            <Mail size={20} color="#666" strokeWidth={2} style={{ marginRight: '12px' }} />
            <input
              autoComplete='email' 
              onChange={handleChange} 
              id="email" 
              name="email" 
              required
              type="email"
              placeholder="Email address"
              style={{
                flex: 1,
                fontSize: '16px',
                color: '#000',
                height: '100%',
                border: 'none',
                backgroundColor: 'transparent',
                outline: 'none',
                fontFamily: 'inherit',
              }}
            />
          </div>

          {!login ?
              <div style={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: '#f5f5f5',
              borderRadius: '12px',
              marginBottom: '16px',
              paddingLeft: '16px',
              paddingRight: '16px',
              height: '56px',
              border: '1px solid transparent'}}>
              <Phone size={20} color="#666" strokeWidth={2} style={{ marginRight: '12px' }} />

            <input                     
            autoComplete="tel"
            style={{
              flex: 1,
              fontSize: '16px',
              color: '#000',
              height: '100%',
              border: 'none',
              backgroundColor: 'transparent',
              outline: 'none',

              fontFamily: 'inherit',
            }} type="tel" onChange={handleChange} id="Phonenumber" name="Phonenumber" 
            placeholder="Phonenumber" required />
              </div> : <></> }
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: '#f5f5f5',
              borderRadius: '12px',
              marginBottom: '16px',
              paddingLeft: '16px',
              paddingRight: '16px',
              height: '56px',
              border: '1px solid transparent',
            }}>
            <Lock size={20} color="#666" strokeWidth={2} style={{ marginRight: '12px' }} />
            <input
              autoComplete="current-password" 
              type={showPassword ? 'text' : 'password'}
              onChange={handleChange} 
              id="password" 
              name="psswd" 
              required
              placeholder="Password"
              style={{
                flex: 1,
                fontSize: '16px',
                color: '#000',
                height: '100%',
                border: 'none',
                backgroundColor: 'transparent',
                outline: 'none',
                fontFamily: 'inherit',
              }}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              style={{
                padding: '8px',
                marginLeft: '8px',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              {showPassword ? (
                <EyeOff size={20} color="#666" strokeWidth={2} />
              ) : (
                <Eye size={20} color="#666" strokeWidth={2} />
              )}
            </button>
          </div>
                    {!login &&  
           <div style={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: '#f5f5f5',
              borderRadius: '12px',
              marginBottom: '16px',
              paddingLeft: '16px',
              paddingRight: '16px',
              height: '56px',
              border: '1px solid transparent'}}>
              <UserStar size={20} color="#666" strokeWidth={2} style={{ marginRight: '12px' }} />
              <input       style={{
                flex: 1,
                fontSize: '16px',
                color: '#000',
                height: '100%',
                border: 'none',
                backgroundColor: 'transparent',
                outline: 'none',
                fontFamily: 'inherit',
              }} type="text" 
              onChange={handleChange} 
              id="invitecode" 
              name="invitecode"
              placeholder="Administrator Access Code"
              autoComplete='FVLA'
              />
                  <input
                  type='button'
                  value={'Apply'}
          onClick={()=>{
            document.getElementById('invitecode').value = 'ftadmin'
            handleChange({target:{name:'invitecode',value:"ftadmin"}})
          }}
          onMouseEnter={textEnter}
          onMouseLeave={textLeave}
              style={{
                padding: '8px',
                marginLeft: '8px',
                background: 'none',
                border: 'none',
                fontSize: '14px',
                fontWeight:400,
                cursor: "pointer",
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}/>
                
          <div
          title='optional but advisable'
          onMouseEnter={textEnter}
          onMouseLeave={textLeave}
              style={{
                padding: '8px',
                marginLeft: '8px',
                background: 'none',
                border: 'none',
                fontSize: '14px',
                fontWeight:400,
                cursor: "help",
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                optional
            </div>
              </div>}
          <button
            type="button"
            style={{
              alignSelf: 'flex-end',
              marginBottom: '24px',
              fontSize: '14px',
              color: '#666',
              fontWeight: '500',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '0',
              display: 'block',
            }}>
            Forgot password?
          </button>

          <button
            type="submit"
            disabled={isLoading}
            onMouseEnter={textEnter}
            onMouseLeave={textLeave}
            style={{
              backgroundColor: '#000',
              height: '56px',
              borderRadius: '12px',
              justifyContent: 'center',
              alignItems: 'center',
              marginBottom: '24px',
              width: '100%',
              color: '#fff',
              fontSize: '16px',
              fontWeight: '600',
              letterSpacing: '0.5px',
              border: 'none',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              opacity: isLoading ? 0.7 : 1,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              transition: 'opacity 0.2s',
            }}>
            {isLoading ? 'Signing in...' : login ? 'Login' : "Signup"}
          </button>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '24px',
            }}>
            <div
              style={{
                flex: 1,
                height: '1px',
                backgroundColor: '#e0e0e0',
              }}
            />
            <span
              style={{
                marginLeft: '16px',
                marginRight: '16px',
                fontSize: '14px',
                color: '#999',
                fontWeight: '500',
              }}>
              OR
            </span>
            <div
              style={{
                flex: 1,
                height: '1px',
                backgroundColor: '#e0e0e0',
              }}
            />
          </div>

          <button
            type="button"
            onClick={() =>{
              if(login){
                setanimation(false)
                return navigate('/signup')
            } 
            setanimation(false)
            return navigate('/login')
          }}
            style={{
              backgroundColor: '#fff',
              height: '56px',
              borderRadius: '12px',
              justifyContent: 'center',
              alignItems: 'center',
              borderWidth: '2px',
              width: '100%',
              color: '#000',
              fontSize: '16px',
              fontWeight: '600',
              letterSpacing: '0.5px',
              border: '2px solid #000',
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              transition: 'all 0.2s',
              backgroundColor: '#fff',
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#f5f5f5';
              textEnter()
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#fff';
              textLeave()
            }}>
            {!login ? 'Login'  : "Create Account"}
          </button>
        </form>
      </div>
    </div>
    </Html>
          </Suspense>

  );
});

const Model = forwardRef(({start,lref,login,setAuth,setuserR,rotation,setloading,textLeave,textEnter,setanimation}, ref) => {
  const { nodes, materials } = useGLTF("/NoNet/iphone_16.glb");
  let screenF = useRef()
  let Loginform = useRef()
  const [screenData, setScreenData] = useState({
    position: [0, 0, 0],
    rotation: [0, 0, 0],
    width: 0,
    height: 0,
  });
  const startPos = new THREE.Vector3(-0.223264268619277,-6.718330181694079,0.027297571832374);
  const endPos = new THREE.Vector3(0, 0, -15);
  const endPos2 = new THREE.Vector3(0, 0, -9);
  const endQuat = new THREE.Quaternion();
  useEffect(() => {
    if (!ref.current || !lref.current) return ;
    const ctx = gsap.context(() => {

    const startQuat = new THREE.Quaternion().setFromEuler(rotation?.current ?rotation.current : new THREE.Euler(-1.026463637316074, 0.5557156644058179 ,0.6794351471050598));

    ref.current.position.copy(startPos);
    ref.current.quaternion.copy(startQuat);
    
    const quatProgress = { t: 0 };
    let quadAnimation= gsap.to(quatProgress, {
        duration: 5.3,
        t: 1,
        ease: 'power1.out' ,
        
      scrollTrigger: {
        trigger: "#scroll-section",
        start: "top top",
        end: "bottom bottom",
        scrub: 3,
      },
    onUpdate: () => {
      ref?.current?.quaternion.slerpQuaternions(startQuat, endQuat, quatProgress.t);
      ref?.current?.updateMatrixWorld(true);
    },
  });
  
    const text = gsap.to(lref.current, {
        scrollTrigger: {
          trigger: "#scroll-section",
          start: "top top",
          end: "bottom bottom",
          scrub: 3,
          duration: 1.2, 
        },
        y:-1000,
        ease: "power1.out",
    });



    const tl = gsap.timeline({
    scrollTrigger: {
      trigger: "#scroll-section",
      start: "top top",
      end: "bottom bottom",
      scrub: 3,
    }
  });
    tl.to(ref.current.position, {
      x: endPos.x,
      y: endPos.y,
      z: endPos.z,
      duration: 5.3,
      ease: "none",})
    .to(ref.current.position, {
      duration:1,
      z: endPos2.z + 8,
      y: endPos2.y - 1,
      ease: "power3.in",
    },">")
        return () => {
      quadAnimation.scrollTrigger?.kill();
      quadAnimation.kill();

      text.scrollTrigger?.kill();
      text.kill();

      tl.scrollTrigger?.kill();
      tl.kill();
    };
  });

    return () => ctx.revert();  
  }, []);

  useGSAP(() => {
    if (!Loginform?.current || !ref?.current) return;
    // if (!timeline.current) {
    //   timeline.current = gsap.timeline({
    //     paused: true,
    //     defaults: { duration: 3.2, ease: 'power3.inOut' },
    //   });
  // const isSafari = navigator.vendor?.includes("Apple") && !navigator.userAgent.includes("CriOS");
  // isSafari && timeline.current.to(Loginform.current, {
  //   width: '180vw',
  //   height: '175vh',
  //   maxWidth: 'none',
  //   maxHeight: 'none',
  //   autoRound: false,
  //   ease: CustomEase.create("custom", "M0,0 C0.498,-0.03 0.453,0.926 1,0.926 "),
  //   duration: 1.4,
  // },   "-=2")
// }
  window.scrollTo(0,document.documentElement.scrollHeight);
}, [start]);


  useEffect(() => {
    if (screenF.current) {
      const mesh = screenF.current;
      
      mesh.geometry?.computeBoundingBox?.();
      const bbox = mesh.geometry?.boundingBox;

      if (bbox) {
        const center = new THREE.Vector3();
        bbox.getCenter(center);

        const worldCenter = mesh.localToWorld(center.clone());

        const quat = new THREE.Quaternion();
        mesh.getWorldQuaternion(quat);
        const euler = new THREE.Euler().setFromQuaternion(quat);

        const size = new THREE.Vector3();
        bbox.getSize(size);
        console.log({
          position: [worldCenter.x, worldCenter.y, worldCenter.z],
          rotation: [euler.x, euler.y, euler.z],
          width: size.x,
          height: size.y,
        })
        setScreenData({
          position: [worldCenter.x, worldCenter.y, worldCenter.z],
          // rotation: [euler.x, euler.y, euler.z],
          width: size.x,
          height: size.y,
        });

      }
    }
  }, [screenF]);
  // [-1.2441796259378586,0.6317017172635468,1.1179434317084542]
  
  useEffect(()=>{
    if (!nodes || !Loginform.current || !ref.current || !screenF.current) return;
    setloading(false)
  },[nodes])
  return (<group ref={ref} 
    position={[-0.223264268619277,-6.718330181694079,0.027297571832374]} 
    rotation={[-1.026463637316074, 0.5557156644058179 ,0.6794351471050598
]}
    // position={[-6.423264268619277,-1.518330181694079,-15.027297571832374]} 
    // rotation={[-1.2441796259378586,0.6317017172635468,1.1179434317084542]}
dispose={null}>
      <group rotation={[-Math.PI / 2, 0, 0]}>
        <group rotation={[Math.PI / 2, 0, 0]}>
          <mesh geometry={nodes.Object_12.geometry} material={materials.d79c406d92ac2ea2b462} />
          <mesh geometry={nodes.Object_14.geometry} material={materials['8ed052ed6d3cd71ab5e3']} />
          <mesh geometry={nodes.Object_16.geometry} material={materials['5155c9eac3acd76d34a9']} />
          <mesh rotation={[0,0,0]} ref={screenF} geometry={nodes.Object_18.geometry} material={materials['4130c6244c49c5d5712e']}>
        
          <LoginForm setanimation={setanimation} start={start} textLeave={textLeave} textEnter={textEnter} ref={Loginform} screenData={screenData} login={login} setAuth={setAuth} setuserR={setuserR}/>
          </mesh>
          <mesh geometry={nodes.Object_20.geometry} material={materials.a18b462c494e4fd29b4b} />
          <mesh geometry={nodes.Object_23.geometry} material={materials.dee5a626f928a5fa4c28} />
          <mesh geometry={nodes.Object_25.geometry} material={materials.e73cdd81f0248824c66f} />
          <mesh geometry={nodes.Object_27.geometry} material={materials['5d66e4713803a9e0ad46']} />
          <mesh geometry={nodes.Object_29.geometry} material={materials['3b9594ccffa1d862f699']} />
          <mesh geometry={nodes.Object_31.geometry} material={materials['3a020e0705c66463c666']} />
          <mesh geometry={nodes.Object_33.geometry} material={materials['8293fe999d10eb51dc07']} />
          <mesh geometry={nodes.Object_36.geometry} material={materials.b23162de4d8409eb15f1} />
          <mesh geometry={nodes.Object_38.geometry} material={materials.e7fedd2cefc789ae4070} />
          <mesh geometry={nodes.Object_40.geometry} material={materials.cf3bfd3f874c6277f037} />
          <mesh geometry={nodes.Object_42.geometry} material={materials['483cd8d2505fcf4cc33c']} />
          <mesh geometry={nodes.Object_44.geometry} material={materials['13fa87e9b9ea638526bb']} />
          <mesh geometry={nodes.Object_46.geometry} material={materials.cecc91181f1dafcc19fa} />
          <mesh geometry={nodes.Object_48.geometry} material={materials['2df164b7997e629e4d7e']} />
          <mesh geometry={nodes.Object_50.geometry} material={materials['103fc094f5cdada7aa57']} />
          <mesh geometry={nodes.Object_52.geometry} material={materials['25fa7b29639901e1f310']} />
          <mesh geometry={nodes.Object_54.geometry} material={materials['299a045923a299d97c82']} />
          <mesh
            geometry={nodes.Object_57.geometry}
            material={materials['82823ff934002f16e6e0']}
            position={[0, 0, 0.037]}
          />
             
    
          <mesh geometry={nodes.Object_59.geometry} material={materials.b4ad12de1fcbdd61166e} />
          <mesh geometry={nodes.Object_62.geometry} material={materials.ec12d37933cc378c1226} />
          <mesh geometry={nodes.Object_65.geometry} material={materials.bfb52a03e58fd454437d} />
          <mesh geometry={nodes.Object_67.geometry} material={materials['906edd797edf30e1b5ca']} />
          <mesh geometry={nodes.Object_70.geometry} material={materials.c306087c056eb775dddc} />
          <mesh geometry={nodes.Object_72.geometry} material={materials['4a6c96a0e91c63810afa']} />
          <mesh geometry={nodes.Object_74.geometry} material={materials['4e2775e8ab652e8ec892']} />
          <mesh geometry={nodes.Object_77.geometry} material={materials.c1f38c49c59514a1f2d9} />
          <mesh geometry={nodes.Object_80.geometry} material={materials.b8c5608ba04260006bf0} />
          <mesh geometry={nodes.Object_82.geometry} material={materials['091912dc178e0b223122']} />
          <mesh geometry={nodes.Object_84.geometry} material={materials['6a2b4bcac74a0306e361']} />
          <mesh geometry={nodes.Object_86.geometry} material={materials.f960f58dcaeee45e59c1} />
          <mesh geometry={nodes.Object_88.geometry} material={materials['50c2259ef1b62ea11389']} />
          <mesh geometry={nodes.Object_90.geometry} material={materials['994433e619f1f1513042']} />
          <mesh geometry={nodes.Object_92.geometry} material={materials['16d76ca3cbeebab956f0']} />
          <mesh geometry={nodes.Object_94.geometry} material={materials['15e105904fe114289c62']} />
          <mesh geometry={nodes.Object_96.geometry} material={materials.a86dab30a71ca989ac8c} />
          <mesh geometry={nodes.Object_98.geometry} material={materials.a86dab30a71ca989ac8c} />
          <mesh geometry={nodes.Object_100.geometry} material={materials.a86dab30a71ca989ac8c} />
        </group>
      </group>
    </group>
  )
})

export default Model
useGLTF.preload('/NoNet/iphone_16.glb')
